<template>
  <div class="payWithdrawRoot">
    <van-sticky>
      <van-nav-bar :border="false" :style="navBgStyle" safe-area-inset-top @click-left="hr.goBack()">
        <template v-if="!hideBack" #left>
          <van-icon name="arrow-left" size="21" :color="navTextColor"/>
        </template>
        <template #title>
          <div style="display:flex;gap:20px;">
            <div v-for="(tab, index) in tabs" :key="tab"
                 @click="onTabClick(index)"
                 :style="{
                   fontSize: activeTab === index ? '17px' : '14px',
                   color: activeTab === index ? navTextColor : navInactiveColor,
                   fontWeight: 'bold',
                   transition: 'font-size 0.3s',
                   cursor: 'pointer',
                 }">
              {{ tab }}
            </div>
          </div>
        </template>
      </van-nav-bar>
    </van-sticky>
    <van-swipe class="payWithdrawSwipe" ref="swipeRef" :loop="false" lazy-render :show-indicators="false" :initial-swipe="activeTab" @change="onSwipeChange">
      <van-swipe-item>
        <Pay :hideLeftBackBtn="true" :hideNav="true"/>
      </van-swipe-item>
      <van-swipe-item>
        <Withdraw :hideNav="true"/>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script setup>
import {ref, computed, onMounted} from 'vue';
import {useRoute} from 'vue-router';
import {hr} from "@/components/utils/HRouter.js";
import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
import Pay from "@/components/pages/Pay.vue";
import Withdraw from "@/components/pages/Withdraw.vue";

const props = defineProps({
  hideBack: {default: false},
});

const route = useRoute();
const activeTab = ref(route.path === '/withdraw' ? 1 : 0);
const tabs = ['充值', '提现'];
const swipeRef = ref();

const navBgStyle = computed(() => {
  const t = HNewGameUIConfig.newGameUIType;
  const bg = t === 1 ? '#FFE88A' : t === 2 ? '#FF7373' : t === 3 ? '#111111' : 'white';
  return {backgroundColor: bg};
});

const navTextColor = computed(() => {
  const t = HNewGameUIConfig.newGameUIType;
  return (t === 2 || t === 3) ? 'white' : 'black';
});

const navInactiveColor = computed(() => {
  const t = HNewGameUIConfig.newGameUIType;
  return (t === 2 || t === 3) ? '#aaa' : '#999';
});

function onTabClick(index) {
  activeTab.value = index;
  swipeRef.value?.swipeTo(index);
}

function onSwipeChange(index) {
  activeTab.value = index;
}
</script>

<style scoped>
/* 修复充值/提现页无法上下滚动、底部按钮被裁切的问题:
   Pay/Withdraw 处在 van-swipe 内, 而横向模式下 van-swipe / __track / van-swipe-item 高度均为 auto,
   导致内部 HScaffold 的 .contentStyle(height:calc(100% - 46px); overflow-y:auto) 坍缩成 auto,
   既不在容器内滚动, 内容超过一屏时底部"充值"按钮就被裁掉。
   这里让容器铺满可用高度并补全高度链(nav 固定 + swipe 占满剩余 + item 满高),
   使 .contentStyle 重新成为可滚动视口(与页面直接进入时的表现一致)。 */
.payWithdrawRoot {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.payWithdrawSwipe {
  flex: 1;
  min-height: 0; /* 允许 flex 子项收缩到低于内容高度, 否则 swipe 会被内容撑高重新溢出 */
}

.payWithdrawSwipe :deep(.van-swipe__track),
.payWithdrawSwipe :deep(.van-swipe-item) {
  height: 100%;
}

/* 此处 HScaffold 隐藏了顶部 nav(hideNav), 无需再为其预留 46px, 否则底部会空出 46px */
.payWithdrawSwipe :deep(.contentStyle) {
  height: 100%;
}
</style>
